module.exports = __webpack_public_path__ + "static/media/Background.535c69d0.md";